import { Box, useTheme } from '@mui/material';
import React from 'react';

import { DocumentsTable } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/DocumentsTable';
import { FormsTable } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/FormsTable';
import { ReadOnlyDocumentsTable } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/ReadOnlyDocumentsTable';

export const DocumentsTab = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}
    >
      <DocumentsTable />
      <FormsTable />
      <ReadOnlyDocumentsTable />
    </Box>
  );
};
